import { createSelector } from "@ngrx/store";
import { MobileAppState } from "./mobile.app.store";
import { MobileAppSubpage, mobileAppSubpages } from "./mobile.data";
import { AppNotification } from "globals/store/app.data";
import { Dictionary } from "@ngrx/entity";
import { sortByProp } from "globals/helpers/helpers";
import { mobileAppFeature, mobileAppStateSelector } from "./mobile.app.era";
import { routerReducer } from "@ngrx/router-store";
import { routerStateSelector } from "src/app/store/router.state";


const router = createSelector(routerStateSelector, (state) => state.state)
const time = createSelector(mobileAppStateSelector, (state) => state.time)
const app = createSelector(mobileAppStateSelector, (state) => state.app) //(store: MobileAppState) => store.app.app
const appInfo = createSelector(mobileAppStateSelector, (state) => state.appInfo) //(store: MobileAppState) => store.app.appInfo
const appData = createSelector(mobileAppStateSelector, (state) => state.appData) // (store: MobileAppState) => store.app.appData
const appId = createSelector(mobileAppStateSelector, (state) => state.id) // (store: MobileAppState) => store.app.id
const notifications = createSelector(mobileAppStateSelector, (state) => state.notifications)


export const onRightAppReselector = createSelector(
  appId, 
  app,
  appInfo, 
  (appId, app, appInfo) => {
    console.log("On right app reselector called", { appId, app, appInfo })
    if (!appId || !appInfo || !app) return false
    return appId === appInfo.id && appInfo.eventId === app.eventId && appId === app.id
  }
)

export const mobileAppNotificationsReselector = createSelector(
  notifications,
  time,
  (notifications: Dictionary<AppNotification>, time): AppNotification[] => Object.values(notifications).sort(sortByProp('pushTime', -1)).filter(n => n.pushTime < time)
)

export const mobileHomePageMenuReselector = createSelector(
  appInfo, // you could use appInfo excludedFieldIds OR you could use the published eventData nested excludedFieldIds
  (appInfo): MobileAppSubpage[] => {
    const defaultSubPages: MobileAppSubpage[] = ['program', 'performers', 'sponsors', 'exhibitors']
    if (!appInfo?.excludedFieldIds) return defaultSubPages
    const ids = appInfo.excludedFieldIds
    return [ 
      ids.includes('programTab') ? null : 'program' as MobileAppSubpage, 
      ids.includes('performersTab') ? null : 'performers' as MobileAppSubpage,
      ids.includes('sponsorsTab') ? null : 'sponsors' as MobileAppSubpage,
      ids.includes('exhibitorsTab') ? null : 'exhibitors' as MobileAppSubpage
    ].filter(p => !!p)
  }
)

export const mobileAppSurveysReselector = createSelector(
  appInfo,
  appData,
  time,
  (appInfo, appData, time) => {

    if (!appInfo?.surveyIds?.length || !appData) return { activeSurveys: [], completedSurveys: [] }
    const activeSurveys = appInfo.surveyIds.filter(id => !appData.completedSurveyIds?.includes(id))
      .map(id => appInfo.surveys[id])
      .filter(s => !!s && s.active && s.pushTime <= time && (!s.endTime || s.endTime > time))

    const completedSurveys = appInfo.surveyIds.filter(id => appData.completedSurveyIds?.includes(id))
      .map(id => appInfo.surveys[id])
      .filter(s => !!s) // allow inactive surveys to show under completed, only deleting them would remove it

    // console.log("Mobile app surveys reselector called", { activeSurveys, completedSurveys, appInfo })
    
    return { activeSurveys, completedSurveys }
  }
)

export const mobileAppSubpageReselector = createSelector(
  router,
  (router): MobileAppSubpage => {
    const [_, mainRoute, appId, subRoute ] = router.url.split("/").map(w => w.toLocaleLowerCase())
    // console.log({ mainRoute, appId, subRoute })
    return subRoute as MobileAppSubpage
  }
)